
import { BUSINESS_UNIT_METADATA } from '../../businessunit/model/business-unit.metadata';
import { ASSETS_USER_DETAILS_METADATA } from '../../userdetails/model/assets-user-details.metadata';
import { EntityMetadata, GenericEntityMetadata, PropertyMetadata, RelationshipType, nullIfContainsNull } from '@scisys-uim/uim-common';


export class TransferAssetApproverMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('TransferAssetApprover', {
      approverId: <PropertyMetadata> {
        name: 'approverId',
        type: 'string',
        plural: false,
        isIdentity: true,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      businessUnit: <PropertyMetadata> {
        name: 'businessUnit',
        type: 'BusinessUnit',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return BUSINESS_UNIT_METADATA;
        },
        byReference: true,
        unique: false
      },
      user: <PropertyMetadata> {
        name: 'user',
        type: 'AssetsUserDetails',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return ASSETS_USER_DETAILS_METADATA;
        },
        byReference: true,
        unique: false
      },
      composedAssetClass: <PropertyMetadata> {
        name: 'composedAssetClass',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      email: <PropertyMetadata> {
        name: 'email',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      sourceKey: <PropertyMetadata> {
        name: 'sourceKey',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      sourceType: <PropertyMetadata> {
        name: 'sourceType',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.approverId;
    return nullIfContainsNull(result);
  }
}



